import React, { useState, useEffect } from 'react';
import { CardContent, Typography, Grid, Box, Drawer, Divider, Button, Modal } from '@mui/material';
import CardData from "../CardData/CardData";
import EditIcon from '@mui/icons-material/ModeEdit';
import { IAccountLegalInformation } from "../../utils/account.types";
import {
  useAppSelector,
} from "../../store/hooks";
import DialogLegalForm from '../DialogLegalForm/DialogLegalForm';
import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';

export default function LegalInformation() {

  const [open, setOpen] = useState(false);
  // const [fetchData, setFetchData] = useState('');

  const accountDetails = useAppSelector(state => state.account.accountDetails);

  const [legalInfo, setLegalInfo] = useState<IAccountLegalInformation>();
  const cardClicked = () => {
    setOpen(true);
  }

  const getData = (data: any): IAccountLegalInformation => {
    const {
      legalName,
      registrationNo,
      smeRegistrationFlag,
      stateOfRegistration,
      countryOfRegistration,
      taxIdentificationNumber1,
      taxIdentificationNumber2,
      companyType

    } = data;
    return {
      legalN: { value: legalName, title: 'Legal Name' },
      registration: { value: registrationNo, title: 'Registration#' },
      country: { value: countryOfRegistration?.name, title: "Country Of Reg." },
      state: { value: stateOfRegistration, title: 'State Of Reg.' },
      tax1: { value: taxIdentificationNumber1, title: 'Tax Indentification #1' },
      tax2: { value: taxIdentificationNumber2, title: 'Tax Indentification #2' },
      companyT: { value: companyType, title: 'Company Type' },
      smeFlag: { value: smeRegistrationFlag ? 'Yes' : 'No', title: "SME Registration" },
    }
  };

  useEffect(() => {
    let legalInfoAvaliable = true;

    const fetchLegalInfo = () => {
      try {
        if (legalInfoAvaliable) {
          Object.keys(accountDetails).length && setLegalInfo(getData(accountDetails));
        }
      } catch (error: any) {
        console.log('Registration and Legal information catch block called')
      }
    };
    fetchLegalInfo();
    return () => {
      legalInfoAvaliable = false;
    };
  }, [accountDetails]);
  const legalData = () => {
    const data = [];
    for (const key in legalInfo) {
      data.push(<CardData key={key} card={legalInfo[key as keyof IAccountLegalInformation]} />)
    }
    return data;
  }

  const closeDialog = (isSaved: boolean) => {
    setOpen(false);

    // if (isSaved) {
    //   setFetchData(Math.random().toString());
    // }
  }

  return (
    <div className={'c-card2'} style={{ padding: 12, paddingTop: 12 }}>
      <Button
        size='small'
        variant="contained"
        style={{
          float: "right",
          color: '#488dff',
          backgroundColor: '#fff',
          border: '0.5px solid #488dff',
          height: 25, borderRadius: 7
        }}
        onClick={cardClicked}
      >Change
      </Button>
      <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, marginBottom:10 }}>Registration &#38; Legal</h5>
      <Divider sx={{ mt: 0.5, mb: 1 }} />
      <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{legalInfo?.companyT.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.companyT.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{legalInfo?.country.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.country.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{legalInfo?.state.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.state.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{legalInfo?.legalN.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.legalN.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{legalInfo?.registration.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.registration.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{legalInfo?.smeFlag.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.smeFlag.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{legalInfo?.tax1.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{legalInfo?.tax1.value || '-'}</h5>

      <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>{legalInfo?.tax2.title}</h5>
      <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>{legalInfo?.tax2.value || '-'}</h5>

      <Modal
            open={open}
            onClose={(event : any, reason:any) => {
                if (reason !== 'backdropClick') {
                    setOpen(true)
                }
            }}
        >
        {<DialogLegalForm open={open} data={accountDetails} onClose={closeDialog}></DialogLegalForm>}
      </Modal>
    </div>
  );
};
